export default __webpack_public_path__ + "static/media/img_outrosConteudos.4c75daf3.svg";